export class Loja {
  id: string;
  idRegional: string;
  descricao: string;
}